import React, {Component} from 'react';

import TButton from '../common/TButton';
import { connect } from 'react-redux'
import { openAllSubCategory, closeAllSubCategory, updateCategoryTree } from '../../actions/category'
import { jsonResponseHandler } from "../../utils/FetchHelper";
import { MAXIMUM_NODE_COUNT } from "../../constants/category/CategoryLimit";
import autobind from 'autobind-decorator'
import CategoryPanel from "./CategoryPanel";
import {addPrefix, isDaumBlogDomain} from "../../utils/UriUtil";
import HTML5Backend from "react-dnd-html5-backend"
import {DndProvider} from "react-dnd"

@connect(state => ({
    categoryTree: state.category.categoryTree,
    currentPath: state.category.treeHelper.indexPath,
    treeHelper : state.category.treeHelper,
    viewChannels: state.category.viewChannels,
    categoryInEditMode: state.category.categoryInEditMode,
    needBulkUpdateChecker : state.category.needBulkUpdateChecker,
    appendedCategoryIds : state.category.appendedCategories,
    updatedCategoryIds : state.category.updatedCategories,
    deletedCategoryIds : state.category.deletedCategories,
    nodeCount : state.category.nodeCount,
    rootCategoryLabel : state.category.rootCategoryLabel,
  }),
  dispatch => ({
    handleOpenAllSubCategory: () => {
      dispatch(openAllSubCategory())
    },
    handleCloseAllSubCategory: () => {
      dispatch(closeAllSubCategory())
    },
    handleUpdateCategoryTree: (categoryTree) => {
      dispatch(updateCategoryTree(categoryTree))
    },
    dispatch
  }))
class CategoryUI extends Component {

  constructor(props) {
    super(props);
  }

  @autobind
  handleSave(callback, failCallback) {

    const { categoryTree, treeHelper, categoryInEditMode, rootCategoryLabel } = this.props;
    const { appendedCategoryIds, updatedCategoryIds, deletedCategoryIds} = this.props;
    const { handleUpdateCategoryTree, dispatch } = this.props;

    if(categoryInEditMode.length > 0) {
      alert('편집을 완료하신 뒤에 카테고리를 저장해주십시오');
      failCallback();
      return null;
    }

    const appendedCategories = treeHelper.getAppendedAndSortedCategories(categoryTree, appendedCategoryIds);
    const updatedCategories = treeHelper.getUpdatedCategories(categoryTree, updatedCategoryIds);
    let categoryData = {
      "rootLabel" : rootCategoryLabel,
      "delete" : deletedCategoryIds,
      "append" : appendedCategories,
      "update" : updatedCategories,
    };

    fetch(addPrefix("/manage/category.json"),
      {
        method: 'put',
        credentials: 'include',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify(categoryData)
      })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        handleUpdateCategoryTree(data.categoryTree);
        callback();
      })
      .catch(e => {
        console.log(e);
        failCallback();
      });
  }

  render() {

    const {
      needBulkUpdateChecker, currentPath, rootCategoryLabel,
      appendedCategoryIds, updatedCategoryIds, deletedCategoryIds,
      nodeCount, handleOpenAllSubCategory, handleCloseAllSubCategory
    } = this.props;

    const currentBulkUpdateCompare = {
      rootCategoryLabel : rootCategoryLabel,
      initialIndexPath : currentPath,
      appendedCategories : appendedCategoryIds,
      updatedCategories : updatedCategoryIds,
      deletedCategories : deletedCategoryIds,
    };

    const infoUrl = isDaumBlogDomain() ? "http://blog.daum.net/ahahblog/13757791" : "http://notice.tistory.com/601"

    return (
      <div className="wrap_set">
        <strong className="tit_set">
          카테고리 순서를 변경하고 주제 연결을 설정할 수 있습니다.
          <a href={infoUrl} className="info_sub" target="_blank">자세히 보기</a>
        </strong>
        <p className="desc_info">드래그 앤 드롭으로 카테고리 순서를 변경할 수 있습니다.</p>
        <div className="bundle_group">
          <span className="count_total">
            <span className="screen_out">카테고리 개수</span>
            <span className="txt_num">{nodeCount}</span> / {MAXIMUM_NODE_COUNT}
          </span>
          <label className="lab_btn btn_group">
            전체 펼치기
            <input type="button" className="btn_g" value="카테고리 전체 펼치기" onClick={(e) => handleOpenAllSubCategory()}/>
          </label>
          <label className="lab_btn btn_group">
            전체 접기
            <input type="button" className="btn_g" value="카테고리 전체 접기" onClick={(e) => handleCloseAllSubCategory()}/>
          </label>
        </div>

        <DndProvider backend={HTML5Backend}>
          <CategoryPanel/>
        </DndProvider>
        <div className="set_btn">
          <TButton onClick={this.handleSave} initialValues={needBulkUpdateChecker} currentValues={currentBulkUpdateCompare}/>
        </div>
      </div>
    );
  }
}

export default CategoryUI;
